import React, { useState, useEffect } from 'react';
import { updateBodyClass } from '../../utils/function';

const ResetPasswordThankYou: React.FC = () => {
  // Add specific class to body on component mount
  useEffect(() => {
    document.title = 'Επιβεβαίωση Αποστολής Email'; // Set the title of the page
    updateBodyClass('auth-page');
    return () => {
      document.title = ''; // Reset title on unmount
      updateBodyClass('');
    };
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
    <div className="confirmation-card text-center">
        <i className="bi bi-envelope-check confirmation-icon"></i>
        <h3 className="mt-3">Ανάκτηση κωδικού</h3>
        <p className="mt-3 mb-4">Σας έχουμε στείλει ένα email με οδηγίες για την επαναφορά του κωδικού σας. Παρακαλούμε ελέγξτε το email σας και ακολουθήστε τις οδηγίες.</p>
        <a href="/" className="btn btn-primary w-100">Επιστροφή στην Αρχική</a>
    </div>
</div>
  );
};

export default ResetPasswordThankYou;

